import { ReactNode } from "react";

interface PageTemplateProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  icon?: ReactNode;
}

export function PageTemplate({ title, subtitle, children, icon }: PageTemplateProps) {
  return (
    <div className='w-full'>
      <div className='p-6'>
        <div className='flex items-center mb-2'>
          {icon && <div className='mr-[8px]'>{icon}</div>}
          <h2 className='text-xl font-medium text-(--gray-3)'>{title}</h2>
        </div>
        <p className='text-gray-600 text-sm text-left'>{subtitle}</p>
      </div>

      <div className='p-6'>{children}</div>
    </div>
  );
}
